'use client';

import * as React from 'react';
import { ThemeContext } from '@mui/styled-engine';
function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}
function useTheme(defaultTheme = null) {
  const contextTheme = React.useContext(ThemeContext);
  return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
export default useTheme;


//////////////////
// WEBPACK FOOTER
// ../@mui/system/esm/useThemeWithoutDefault.js
// module id = 302
// module chunks = 25